import { FC } from "react";

import useOutsideClick from "../../hooks/useOutsideClick";

import "../../styles/modal.css";

interface ModalProps {
  modalOpen: boolean;
  handleModalClose: () => void;
}

const Modal: FC<ModalProps> = ({ modalOpen, handleModalClose }) => {
  const modalRef = useOutsideClick(handleModalClose);

  if (!modalOpen) {
    return null;
  }

  return (
    <div id="modal">
      <div className="overlay"></div>
      <div ref={modalRef} className="modal-layout">
        <div className="modal-top">
          <h4>Nasıl çalışıyor?</h4>
          <button onClick={handleModalClose} className="modal-close">
            <img src="./images/close.png" alt="close" />
          </button>
        </div>
        <div className="modal-text">
          📝 Elindeki malzemeleri yaz veya aklındaki yemeği söyle, Bundle AI
          sana yemek tarifi önerilerini sunarak rehberlik etsin.
          <br />
          <br />
          🍽️ Beko Küçük Ev Aletleri ile hazırlayacağın yemeklerle sofrana lezzet
          kat!
        </div>
      </div>
    </div>
  );
};

export default Modal;
